module.exports = __webpack_public_path__ + "img/home.1feeed2f.png";